import '../css/imprimirMesasGafetes.css';
import '../css/imprimir.css';

import bgMesa from '../assets/bgPrintMesa.png';
import logoMesa from '../assets/logoUnionMesas.png';

import bgGafete from '../assets/bgPrintGafete.png';
import logoGafete from '../assets/logoUnionGafete.png';

export const ImprimirMesasGafetes = ({ cantidadMesas, inscriptos }) => {

    const isMesas = !!cantidadMesas && cantidadMesas > 0;
    const isGafetes = !!inscriptos && Array.isArray(inscriptos) && inscriptos.length > 0;

    if (!isMesas && !isGafetes) return null;

    const fondo = isMesas ? bgMesa : bgGafete;
    const logo = isMesas ? logoMesa : logoGafete;

    const items = isMesas
        ? Array.from({ length: cantidadMesas }, (_, i) => ({
            id: i,
            mesa: (i + 1).toString().padStart(2, "0"),
            nombre: null
        }))
        : inscriptos.map((nombre, i) => ({
            id: i,
            mesa: null,
            nombre
        }));

    return (
        <>
            <span className="paragraphFontPreloader">Preloader</span>
            <div id={isMesas ? "imprimirMesas" : "imprimirGafetes"} className="seccionImprimir">
                {items.map(({ id, mesa, nombre }) => (
                    <div
                        key={id}
                        className={`position-relative paginaImprimir paginaImprimirMesa`}
                    >
                        <img src={fondo} className="bg-imprimir" alt="" />

                        <div className="contenidoImprimir">
                            {isMesas ? (
                                <>
                                    <p className="titleMesa m-0">Mesa</p>
                                    <p className="numberMesa m-0">{mesa}</p>
                                </>
                            ) : (
                                <p className="nombreIncripto m-0">{nombre}</p>
                            )}
                        </div>

                        <img
                            src={logo}
                            className={`${isMesas ? "logoUnionMesa" : "logoUnionGafete"}`}
                            alt=""
                        />
                    </div>
                ))}
            </div>
        </>
    );
};
